// extracted by mini-css-extract-plugin
module.exports = {"Container":"Grills_Container__2v0-U","Description":"Grills_Description__3ru_4","List":"Grills_List__y0E6H"};